import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const AlertModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.31652 5.36637C10.4221 3.15522 13.5775 3.15522 14.6831 5.36636L19.829 15.6582C20.8263 17.6529 19.3758 19.9998 17.1457 19.9998H6.85391C4.62376 19.9998 3.17327 17.6529 4.17063 15.6582L9.31652 5.36637Z"
            fill="url(#paint0_linear_123_14414)"
          />
          <path
            d="M11.0712 8.49746C11.0327 7.95846 11.4596 7.5 12 7.5C12.5404 7.5 12.9673 7.95846 12.9288 8.49746L12.5356 14.0013C12.5156 14.2823 12.2817 14.5 12 14.5C11.7183 14.5 11.4844 14.2823 11.4644 14.0013L11.0712 8.49746Z"
            fill="#5C001B"
          />
          <circle cx="12" cy="16.5" r="1" fill="#5C001B" />
          <defs>
            <linearGradient
              id="paint0_linear_123_14414"
              x1="7.92492"
              y1="8.15122"
              x2="8.55926"
              y2="19.9786"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F79B5C" />
              <stop offset="1" stop-color="#FCFF56" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default AlertModule;
